/**
 * AIW1-F6 (the 117th, his "prefill from the record") and its review: the record's acreage and lot SF fill the LOI's
 * Acres and Lot SF boxes as ONE fact in two units.
 * ⛔ If he states either figure, the record gives neither - "2.6 acres" beside the record's 110,642 SF (2.54 acres)
 *    printed a letter that contradicts itself. ⛔ A lot SF with no acres before it reads as a second building size in the
 *    RE line ("retail building (+/- 110,642 SF)"), so the record's lot SF comes only with its acres (3 of 11,661 records
 *    hold one without the other, measured 2026-10-04).
 */
export const recordSiteSize = (
  record: { acres?: number | null; lotSf?: number | null } | null | undefined,
  stated: { acres?: unknown; lotSf?: unknown },
): { acres: number | null; lotSf: number | null } => {
  if (stated.acres != null || stated.lotSf != null) return { acres: null, lotSf: null };
  const acres = record?.acres ?? null;
  return acres == null ? { acres: null, lotSf: null } : { acres, lotSf: record?.lotSf ?? null };
};
